module.exports = __webpack_public_path__ + "static/media/settings.33e8dc31.svg";